<template>
  <ModalContainer queryParam="editImage" ref="modalEditImagen" size="lg">

    <h3 class="text-center my-2">Editar Imagen Enviada</h3>

    <FormAddImagen
      v-if="indexToEdit"
      :imagenesList="imagenesList"
      :indexToEdit="indexToEdit"
      @closeModal="cerrarModal"
    />
      
  </ModalContainer>
    
</template>

<script>

import { ModalContainer } from '@/shared/components';
import FormAddImagen from './FormAddImagen.vue';

export default {

  name: "EditarEnvioImagen",


  props: {
    imagenesList: {
      type: Array,
      required: true
    }
  },

  components: {
    FormAddImagen,
    ModalContainer
  },


  created(){
    this.indexToEdit = this.$route.query.editImage;
  },


  data() {
    return {
      indexToEdit: null,
    }
  },


  methods: {

    cerrarModal(){
      this.$refs.modalEditImagen.closeModal();
    }
  },

  watch:{
    '$route.query.editImage':{
      handler(){
        this.indexToEdit = this.$route.query.editImage;
      }
    }
  }
}
</script>
